import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import { Order } from '../../../WebAPI'
// import HistoryModal, { HistoryModalTrigger } from '../../shared/HistoryModal'
import HistoryModal, { HistoryModalTrigger } from 'src/features/shared/HistoryModalNew'
import { accEntryViewHistory } from 'src/store/accEntry'

const HistoryButton: FC<{
  FormName: string
  name: string
}> = ({ FormName, name }) => {
  const selectFormValue = formValueSelector(FormName)

  const visible: boolean = useSelector((state) => selectFormValue(state, 'action') === 'edit')
  const ID: number = useSelector((state) => selectFormValue(state, 'EntryID'))
  const hash: string = useSelector((state) => selectFormValue(state, 'HashSum_EntryID_'))

  if (visible) {
    return (
      <>
        {/* @ts-ignore */}
        {/* <HistoryModalTrigger ID={ID} hash={hash} page="viewhistory" />
        <HistoryModal name={name} APICall={Order.details} /> */}

        {/* @ts-ignore */}
        <HistoryModalTrigger EntryID={ID} HashSum_EntryID_={hash} page="viewhistory" />
        <HistoryModal name={name} APICall={accEntryViewHistory} />
      </>
    )
  }

  return null
}

export default HistoryButton
